import http from './client';

/**
 * Tag OpenAPI: Users
 * POST /check-email, POST /signup — públicos (sin JWT).
 */

/**
 * @param {{ email: string }} body
 * @returns {Promise<import('axios').AxiosResponse<{ exists: boolean }>>}
 */
export function checkEmail(body) {
  return http.post('/check-email', body);
}

/**
 * Registro público docente (rol teacher asignado en servidor).
 * @param {{ email: string, password: string, profile: Record<string, string> }} body
 * @returns {Promise<import('axios').AxiosResponse<{ id: string, email: string }>>}
 */
export function signup(body) {
  return http.post('/signup', body);
}

export const usersApi = {
  search: (q) => http.get('/users/search', { params: { q } }),
};

export const teachersApi = {
  list: (params = {}) => http.get('/teachers', { params }),
  get: (userId) => http.get(`/teachers/${userId}`),
};
